var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { I18nextProvider } from "react-i18next";
import "./const/iconLibrary";
import { ThemeProvider } from "styled-components";
import VantageContextProvider from "./context/vantageContext";
import { ConfigProvider } from "./hooks/useConfig";
import vantageI18n from "./strings/i18n";
import Vantage from "./ui";
import ErrorBoundary from "./ui/templates/ErrorBoundary";
import ErrorPage from "./ui/templates/ErrorPage";
import theme from "./ui/theme";
var VantageRoot = function (_a) {
    var config = _a.config, navigateToDashboard = _a.navigateToDashboard;
    return (_jsx(ConfigProvider, __assign({ value: config }, { children: _jsx(I18nextProvider, __assign({ i18n: vantageI18n }, { children: _jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(ErrorBoundary, __assign({ fallbackComponent: _jsx(ErrorPage, {}) }, { children: _jsx(VantageContextProvider, __assign({ navigateTo: navigateToDashboard }, { children: _jsx(Vantage, {}) })) })) })) })) })));
};
export default VantageRoot;
